import React from 'react';

import { Provider } from 'react-redux';
import store, { persistor } from 'store/store';
import { PersistGate } from 'redux-persist/integration/react';

import Routes from './routes';
import { BrowserRouter } from 'react-router-dom';

import theme from 'theme';
import { ChakraProvider } from '@chakra-ui/react';

import { queryClient } from 'utils';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { ErrorBoundary } from 'react-error-boundary';

import ErrorFallback from 'components/core/ErrorFallback';
import LoadingIndicator from 'components/primitives/LoadingIndicator';

const onRehydrate = () => {
  console.log('Redux state rehydration initialized');
};

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme} resetCSS>
        <ErrorBoundary fallback={<ErrorFallback />}>
          <Provider store={store}>
            <PersistGate
              loading={<LoadingIndicator />}
              persistor={persistor(onRehydrate)}>
              <BrowserRouter>
                <Routes />
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </ErrorBoundary>
      </ChakraProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
